import { gql, useMutation } from '@apollo/client';
import { Pda } from './components/Pda';
import { Header } from './components/Header';
import { HandleScanEventResult, VehicleRelatedScanComponent } from './components/VehicleRelatedScanComponent';
import { t } from '../../i18n';


const HANDLE_WHS_UNSEALING_SCAN_EVENT = gql`
mutation HandleWhsUnsealingScanEvent($licensePlate: String!, $sealNo: String!) {
  success: handleWhsUnsealingScanEvent(licensePlate: $licensePlate, sealNo: $sealNo)
}
`

const PageBody = () => {

  const [handleWhsUnsealingScanEvent] = useMutation<HandleScanEventResult>(HANDLE_WHS_UNSEALING_SCAN_EVENT);

  const handleScanEvent = async (value1: string, value2: string): Promise<HandleScanEventResult> => {
    const {data} = await handleWhsUnsealingScanEvent({ variables: { licensePlate: value1, sealNo: value2 } });
    return {success: data?.success || false};
  };

  return (
    <VehicleRelatedScanComponent
      value1Placeholder={t('pda.pages.unsealing.licensePlate')}
      value2Placeholder={t('pda.pages.unsealing.sealNO.')}
      value1ColumnTitle={t('pda.pages.unsealing.licensePlate')}
      value2ColumnTitle={t('pda.pages.unsealing.sealNO.')}
      isCheckBarCodeValid={false}
      handleScanEvent={handleScanEvent}
    />
  );
}

export default function UnsealingPage() {
  return (
    <div className="w-full h-full flex flex-col gap-2 p-2">
      <Header title={t('pda.pages.unsealing.unsealingScan')} />
      <Pda />
      <PageBody />
    </div>
  );
}